<template>
  <v-fade-transition mode="out-in">
    <router-view/>
  </v-fade-transition>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data: () => ({
    routes: [
      {
        to: "/admin/courses",
        text: "Courses"
      },
      {
        to: "/admin/staff",
        text: "Staff"
      },
      {
        to: "/admin/academic",
        text: "Academic"
      },
      {
        to: "/admin/administrators",
        text: "Administrators"
      },
      {
        to: "/admin/organisations",
        text: "Organisations"
      }
    ]
  }),
  methods: {
    ...mapMutations(["setRoutes"])
  },
  mounted() {
    this.setRoutes(this.routes);
  }
};
</script>
